import { useState, useEffect, useContext } from "react";
import axios from "axios";
import { useSelector, useDispatch } from "react-redux";
import { useLocationContext } from "../../context/LocationContext";
import { UserContext } from "../../context/UserContext";
import { openCartSlider } from "../../Redux/cartSliderSlice";

export default function useNavbarAPI() {
  const [customerName, setCustomerName] = useState("");

  const { user, logoutUser } = useContext(UserContext);
  const dispatch = useDispatch();

  const cartItems = useSelector((state) => state.cart.items || []);
  const totalItems = cartItems.reduce((sum, item) => sum + (item.quantity || 1), 0);

  const { address, loading, fetchLocation } = useLocationContext();

  useEffect(() => {
    if (typeof fetchLocation === "function") {
      fetchLocation();
    }
  }, []);

  useEffect(() => {
    const fetchCustomer = async () => {
      try {
        const userId = user?.userId;
        if (!userId) return;

        const API_URL = process.env.REACT_APP_API_URL;
        const response = await axios.get(
          `${API_URL}MasterAPI/GetCustomersById?id=${userId}`
        );
        const customer = response?.data?.data;
        if (customer?.customerName) {
          setCustomerName(customer.customerName);
        }
      } catch (error) {
        console.log("CUSTOMER ERROR", error);
      }
    };
    fetchCustomer();
  }, [user]);

  const displayName = customerName || "User";

  const openCart = () => {
    dispatch(openCartSlider());
  };

  const confirmLogout = () => {
    logoutUser();
    window.location.href = "/signin";
  };

  return {
    user,
    totalItems,
    address,
    loading,
    fetchLocation,
    displayName,
    openCart,
    confirmLogout,
  };
}